<!-- 模糊查询 -->
<template>
  <ul class="pz_one qd_one">
    <li>
      <input
        v-model="formData.vagueField"
        type="text"
        class="txt"
        placeholder="单位/姓名/展位号"
      />
    </li>
    <li>
      <a-button :loading="btnLoading" class="btnNext" @click="search">查询</a-button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    btnLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        alias: this.$route.query.alias,
        signId: this.$route.query.configuration,
        signMode: "Vague",
        vagueField: "",
      },
    };
  },
  methods: {
    async search() {
      if (this.formData.vagueField === "") {
        this.$message.warning("请输入查询条件");
        return;
      }
      this.$emit("search", this.formData);
    },
  },
};
</script>
